'use client'
import React from 'react'
import BreadCrumbs from '../../sections/breadcrumbs'
import Information from '../../sections/informationSmart'
import SkewedCta from '../../sections/skewedCta'
import LocationSquareSection from '../../sections/locationsSquareSection'
import MediaTextSection from '../../sections/mediaText'

const InfoIndexPage = ({
  intro_text,
  breadcrumbs,
  location_link_section,
  categories,
  cta,
  mediatext,
}) => {
  const {
    title: intro_title,
    text: intro_description,
    lists: intro_lists,
  } = intro_text?.length ? intro_text[0].value : {}

  const {
    title: locationsTitle,
    text: locationsText,
    links: locations,
  } = location_link_section || {}

  const showCta = cta && cta.length > 0 ? cta[0].value : null
  const showMediaText =
    mediatext && mediatext.length > 0 ? mediatext[0].value : null
  return (
    <>
      <BreadCrumbs breadcrumbs={breadcrumbs} spacing={77} widthVariant="full" />
      <Information
        intro={{
          text: intro_description,
          title: intro_title,
        }}
        content={categories}
      />

      {showCta?.link && (
        <SkewedCta
          title={showCta?.link?.text}
          text={showCta?.text}
          href={showCta?.link?.href}
          image={showCta?.image}
          addShadow={false}
          padding={95}
        />
      )}
      <LocationSquareSection
        title={locationsTitle}
        text={locationsText}
        blocks={locations.slice(0, 3)}
      />

      {showMediaText && (
        <MediaTextSection
          title={showMediaText.title}
          button={showMediaText.button}
          text={showMediaText.text}
          image={showMediaText.image}
          variant={showMediaText.variant}
          overlap={false}
        />
      )}
    </>
  )
}

export default InfoIndexPage
